import { createFileRoute } from '@tanstack/react-router';

import { ReportingDelivery } from 'component/partial/Reporting/ReportingDelivery';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/reporting/delivery')({
  component: ReportingDeliveryRoute,
});

function ReportingDeliveryRoute() {
  return <ReportingDelivery />;
}
